export default __webpack_public_path__ + "static/media/totalamont.9912c123.svg";